import { GalleryList } from './gallery'

class AllSalesList extends GalleryList {
    
    getEntityKey() {
        return 'photographer/all_sales'
    }
}

export const allSalesList = new AllSalesList('all_sales_default')
export const mobileAllSalesList = new AllSalesList('all_sales_mobile')
